// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorResponse_wrapper__TmQZD","errorBody":"ErrorResponse_errorBody__SGrX-","toastHeader":"ErrorResponse_toastHeader__DM9Gq"};